/**
 * Dual-scroll sticky sidebar.
 * Both sidebar and main content scroll naturally together.
 * When the sidebar reaches its bottom, it sticks while main content continues.
 * When scrolling back up, the sidebar unsticks and scrolls until it reaches the top, then sticks there.
 */
(function () {
  const SELECTOR = '[data-dual-scroll-sidebar]';
  const MEDIA_QUERY = '(min-width: 768px)';

  function initDualScroll(sidebar) {
    let lastScrollY = window.scrollY;
    let currentTop = 0;
    let ticking = false;

    function getHeaderOffset() {
      const sticky = document.querySelector('.sticky-header.show');
      return sticky ? sticky.offsetHeight : 0;
    }

    function update() {
      ticking = false;

      if (!window.matchMedia(MEDIA_QUERY).matches) {
        sidebar.style.position = '';
        sidebar.style.top = '';
        return;
      }

      const scrollY = window.scrollY;
      const delta = scrollY - lastScrollY;
      lastScrollY = scrollY;

      if (delta === 0) return;

      const headerOffset = getHeaderOffset();
      const viewportH = window.innerHeight;
      const sidebarH = sidebar.offsetHeight;

      // If sidebar fits in viewport, simple sticky
      if (sidebarH <= viewportH - headerOffset) {
        sidebar.style.position = 'sticky';
        sidebar.style.top = headerOffset + 'px';
        return;
      }

      // The minimum top value (sidebar bottom aligns with viewport bottom)
      const minTop = -(sidebarH - viewportH);
      // The maximum top value (sidebar top aligns below header)
      const maxTop = headerOffset;

      // Adjust currentTop based on scroll delta
      // When scrolling down (delta > 0), top should decrease (sidebar moves up relative to viewport)
      // When scrolling up (delta < 0), top should increase (sidebar moves down relative to viewport)
      currentTop = currentTop - delta;

      // Clamp between min and max
      currentTop = Math.max(minTop, Math.min(maxTop, currentTop));

      sidebar.style.position = 'sticky';
      sidebar.style.top = currentTop + 'px';
    }

    // Initialize currentTop based on current state
    const headerOffset = getHeaderOffset();
    currentTop = headerOffset;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initDualScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
